import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  className?: string;
  onClick?: () => void;
}
const CHECKOUT_URL = 'https://myschoolofbusiness.com/cart/47638318088386:1';
export function CtaButton({
  className = '',
  onClick
}: CtaButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    window.location.href = CHECKOUT_URL;
  };
  return <motion.button whileHover={{
    scale: 1.02,
    y: -2
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative flex flex-col items-center justify-center w-full sm:w-auto bg-gold hover:bg-gold-light text-forest-dark font-bold py-4 px-6 md:px-10 rounded-xl shadow-gold-glow transition-colors duration-300 ${className}`} data-id="element-22">
      <div className="flex items-center text-lg md:text-xl text-center leading-tight" data-id="element-23">
        <ShoppingCart className="w-6 h-6 mr-3 flex-shrink-0" data-id="element-24" />
        <span data-id="element-25">¡SÍ, QUIERO MI CÓDIGO METABÓLICO Y MIS 5 BONOS POR $9.97!</span>
      </div>
      <span className="text-sm md:text-base font-medium opacity-80 mt-1" data-id="element-26">
        (Acceso inmediato después de la compra)
      </span>
    </motion.button>;
}